export const HA_UNIT = "000001";

export interface UnitOfMeaseureFamily {
    ext_code: string;
    cod_family: string;
    sco_family: string;
    ds_family: string;
    de_family: string;
    applicable_to_resource: number;
}

export interface UnitOfMeasure {
    ext_code: string;
    sco_unit_of_measure: string;
    cod_unit_of_measure: string;
    ds_unit_of_measure: string;
    de_unit_of_measure: string;
    default_unimis: number;
    unit_of_measure_family_name: string;
}

export interface UnitOfMeasureCollection {
    [family_name: string]: UnitOfMeasure[];
}

export interface UnitConversion {
    conversion_sco: string;
    conversion_ext: string;
    factor: number;
}

